import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import CustomTooltip from './CustomTooltip';
import React from 'react';
import { useTheme } from '@material-ui/core';
import AnalyticsPanel from '../../components/AnalyticsPanel';
import { alpha } from '@material-ui/core/styles';

const BarUtilizationByOr = ({ data, generalAnalytics = false }) => {
  const theme = useTheme();

  return (
    <AnalyticsPanel title="Utilization % By OR">
      <ResponsiveContainer width="100%" height="100%" {...(!generalAnalytics && { aspect: 0.85 })}>
        <BarChart
          barGap={20}
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: -30,
            bottom: 5,
          }}
        >
          <CartesianGrid stroke={alpha(theme.palette.divider, 0.1)} strokeArray="1 1" />
          <XAxis type="category" dataKey="title" stroke="rgba(255,255,255,0.25)" />
          <YAxis
            type="number"
            domain={[0, 'dataMax']}
            tickFormatter={(value) => Math.round(value).toString()}
            tick={{
              color: alpha(theme.palette.divider, 0.05),
              fontSize: '0.7em',
            }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            content={({ active, payload, label }) => (
              <CustomTooltip active={active} payload={payload} label={label} useTitle unit="%" decimal={false} />
            )}
            cursor={{ fill: 'rgba(255,255,255,0.15)' }}
            contentStyle={{
              backgroundColor: theme.palette.background.paper,
              borderRadius: 4,
              border: 0,
            }}
          />
          <Bar dataKey="pipoUtilization" stackId="a" fill="#00A7F7" />
        </BarChart>
      </ResponsiveContainer>
    </AnalyticsPanel>
  );
};

export default BarUtilizationByOr;
